export default __webpack_public_path__ + "static/media/52.b0ecb2cb.svg";